import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IPayrollChangeRequestState } from './payrollchangerequest.types';
import { IPayrollChangeRequestData, IUserData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { Transition } from '@/models/transition';

export const state: IPayrollChangeRequestState = {
  version: 1,
  payrollChangeRequests: [] as IPayrollChangeRequestData[],
  count: 0,
  hrPersonnels: [] as IUserData[],
  activities: [] as Transition[],
  lastPromise: null
};

const namespaced = true;

export const payrollChangeRequest: Module<
  IPayrollChangeRequestState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
